import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';

import Picture from '../../components/Picture'
import CheckList from '../../components/site/CheckList/CheckList'
import CheckListItem from '../../components/site/CheckList/CheckListItem'

export default class TwoColsB2B extends Component {
    render() {
        return (
            <Fragment>
                <section className='container two-col'>
                    <div className="column">
                        <h3 className='title-light'>Fique disponível no <strong>momento exato</strong> que seus clientes querem comprar</h3>
                        <CheckList>
                            <CheckListItem>
                                <h4><strong>Site exclusivo da sua empresa</strong>: suamarca.mercos.com.br</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Canal de vendas digital: <strong>funciona 24h, sem parar</strong></h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Totalmente responsivo</strong>: seus clientes podem acessarem qualquer dispositivo</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/b2b/fique-disponivel.png"
                            alt='Fique disponível no momento exato que seus clientes querem comprar'
                            mobileSrc="/images/site/landing-pages/b2b/fique-disponivel-mobile.png"
                        />
                    </div>
                </section>
                <section className='container two-col'>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/entrada-pedidos.png"
                            alt='Elimine erros operacionais'
                            mobileSrc="/images/site/landing-pages/entrada-pedidos-mobile.png"
                        />
                    </div>
                    <div className="column">
                        <h3 className='title-light'><strong>Elimine erros operacionais</strong></h3>
                        <CheckList>
                            <CheckListItem>
                                <h4><strong>Chega de pedidos errados</strong> por digitação no WhatsApp e e-mail</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Centralize seus pedidos num só lugar</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Integrado ao força de vendas Mercos e seu ERP</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                </section>
                <section className='container two-col'>
                    <div className="column">
                        <h3 className='title-light'><strong>Aliado dos vendedores</strong></h3>
                        <CheckList>
                            <CheckListItem>
                                <h4>Representantes e o televendas podem ter um vendedor online</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Podem vender para clientes menores ou em lugares que estão fora da sua rota</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Sem conflitos</strong>: você pode atribuir os pedidos para o vendedor que já atende a região do cliente</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Quando o cliente faz um orçamento, os vendedores podem ser estratégicos</strong>: ligando para oferecer outros produtos e aumentar o pedido</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Mais tempo para atender clientes</strong>: prospectando o relacionamento, trabalhando o PDV do lojista, ajudando na estratégia de lançamentos e promoções e prospectar novos clientes</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/b2b/aliado.png"
                            alt='Aliado dos vendedores'
                        />
                    </div>
                </section>
                <section className='container two-col'>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/b2b/mapa.png"
                            alt='Conquiste mercados'
                        />
                    </div>
                    <div className="column">
                        <h3 className='title-light'><strong>Conquiste mercados</strong></h3>
                        <CheckList>
                            <CheckListItem>
                                <h4>Comece a atuar rápido em novas regiões</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Marque território antes do seu concorrente</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Aumente seu market share</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Venda mais para seus clientes menores</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Recupere clientes inativos</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                </section>
                <section className='container two-col'>
                    <div className="column">
                        <h3 className='title-light'><strong>Personalizado para o seu negócio</strong></h3>
                        <CheckList>
                            <CheckListItem>
                                <h4><strong>Acesso Restrito</strong>: apenas clientes com login e senha podem acessar seu catálogo e preços</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Personalize seu catálogo</strong>: mostre ou oculte categorias de produtos de acordo com cada cliente, região ou segmento</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Você decide o preço e condições que quer mostrar</strong>: configure tabelas de preços e políticas comerciais de acordo com cada cliente, região ou segmento</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4><strong>Design</strong>: deixe o catálogo B2B com a cara da sua empresa</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/b2b/personalize.png"
                            alt='Personalizado para o seu negócio'
                        />
                    </div>
                </section>
                <section className='container two-col'>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/entrada-pedidos.png"
                            alt='Mais produtividade, menos custos'
                            mobileSrc="/images/site/landing-pages/entrada-pedidos-mobile.png"
                        />
                    </div>
                    <div className="column">
                        <h3 className='title-light'><strong>Mais produtividade, menos custos</strong></h3>
                        <CheckList>
                            <CheckListItem>
                                <h4>Economize nos deslocamentos, hospedagens, passagens e alimentação do seu time de vendas</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Diminua visitas de reposição improdutivas</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Seus clientes podem acompanhar o status do pedido. Nada dos vendedores ficarem respondendo WhatsApp</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Reposições: Seus clientes têm acesso ao histórico de pedidos e podem fazer reposição sem depender da própria memória e do vendedor</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                </section>
                <section className='container two-col'>
                    <div className="column">
                        <h3 className='title-light'><strong>Fomente promoções e lançamentos</strong></h3>
                        <CheckList>
                            <CheckListItem>
                                <h4>Use o banner principal e chame a atenção para os principais produtos que você quer vender</h4>
                            </CheckListItem>
                            <CheckListItem>
                                <h4>Crie categorias exclusivas para promoções ou lançamentos</h4>
                            </CheckListItem>
                        </CheckList>
                    </div>
                    <div className="column">
                        <Picture
                            className=''
                            src="/images/site/landing-pages/b2b/promocoes-lancamentos.png"
                            alt='Fomente promoções e lançamentos'
                        />
                    </div>
                </section>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/TwoColsB2B.jsx